























import { Component, Prop, Mixins } from 'vue-property-decorator'
import BaseVue from '@/mixins/BaseVue'

@Component
export default class StarsPicker extends Mixins(BaseVue) {
  @Prop() public value?: number
  @Prop() public disabled!: boolean
  @Prop({ default: 3 })
  public max!: number

  public onChanged(value: number) {
    if (!this.disabled && value <= this.max) {
      this.$emit('input', value)
    }
  }
}
